module.exports = __webpack_public_path__ + "media/07 Sind die Lichter angezündet.5276d82b.wav";